module.exports = __webpack_public_path__ + "static/videos-d4d22e5faea597baa1dfb9cb3f1f5538.mp4";